import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// ASSET SALE APIs
// Legacy route: /Purchase/AssetSale
// ==============================================

// 1. Get Asset Item Codes eligible for sale (GET)
export const getAssetItems = async ({ uid, rid }) => {
    try {
        const queryParams = new URLSearchParams({ UID: uid, RID: rid });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/AssetItems?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Asset Items API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Add an item to the staging list (POST)
export const saveAssetSaleItems = async ({ itemId, createdBy }) => {
    try {
        const payload = { ItemId: parseInt(itemId, 10), Createdby: createdBy };
        const response = await axios.post(
            `${API_BASE_URL}/Purchase/SaveAssetSaleItems`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save Asset Sale Items API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get the staged item details grid (GET)
export const getAssetSaleItemDetails = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetAssetSaleItemDetails`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Asset Sale Item Details API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get the asset's book value ceiling for the staged item (GET)
export const getAssetAmount = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetAssetAmount`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Asset Amount API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Delete a staged item row (POST)
export const deleteAssetSaleItem = async (iId) => {
    try {
        const payload = { IId: iId };
        const response = await axios.post(
            `${API_BASE_URL}/Purchase/DeleteAssetSaleItem`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Delete Asset Sale Item API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 6. Save the Asset Sale request (POST)
export const saveAssetSaleData = async (params) => {
    try {
        const payload = {
            ItemId: parseInt(params.itemId, 10),
            Itemcodes: params.itemCode,
            Date: params.date,
            BookValueDate: params.bookValueDate,
            PartyName: params.partyName,
            PartyAddress: params.partyAddress,
            AssetAmount: params.assetAmount,
            SellAmount: params.sellAmount,
            Remarks: params.remarks,
            Profit: params.profit,
            Loss: params.loss,
            RoleID: params.roleId,
            Createdby: params.createdBy,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Purchase/SaveAssetSaleData`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save Asset Sale Data API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
